<template>
  <div
    v-if="opportunityBeingVisited.sponsorship.isActive"
    id="sponsorships-info"
    class="container"
  >
    <div class="columns">
      <div id="sponsorships-box" class="column box">
        <sponsorships-title
          title="Patrocínios"
          buttonText="Solicitar"
          :description="description"
          :isCardOpen="isCardOpen"
          @open-card="$emit('open-card', 'sponsorship')"
          @close-card="$emit('close-card', 'sponsorship')"
        />

        <div class="columns action-details" v-if="isCardOpen">
          <prerequisites
            :advance="opportunityBeingVisited.sponsorship.advance"
            :limitDateForRequests="opportunityBeingVisited.limitDateForRequests"
            :limitDateForActions="opportunityBeingVisited.limitDateForActions"
            :courses="opportunityBeingVisited.sponsorship.courses"
            :states="opportunityBeingVisited.sponsorship.states"
          />

          <counterparts
            :treatmentPronoun="opportunityBeingVisited.treatmentPronoun"
            :businessName="opportunityBeingVisited.businessName"
            :logosZipURL="opportunityBeingVisited.page.logosZipURL"
            action="o evento / projeto patrocinado"
          />
        </div>
      </div>
    </div>

    <b-modal :active.sync="isRequestModalActive">
      <sponsorship-request-modal />
    </b-modal>
  </div>
</template>

<script>
import { descriptions } from "../../../assets/js/actions-descriptions";
import sponsorshipsTitle from "./card/Title";
import prerequisites from "./card/Prerequisites";
import counterparts from "./card/Counterparts";
import sponsorshipRequestModal from "../request-modal/SponsorshipRequestModal";

export default {
  props: ["opportunityBeingVisited", "isCardOpen"],

  components: {
    sponsorshipsTitle,
    prerequisites,
    counterparts,
    sponsorshipRequestModal
  },

  data() {
    return {
      description: "",
      isRequestModalActive: false
    };
  },

  mounted() {
    this.description = descriptions.sponsorship;
  }
};
</script>

<style scoped>
#sponsorships-info {
  margin-top: 3rem;
}
@media (max-width: 1023px) {
  #sponsorships-info {
    margin-left: 1.5rem;
    margin-right: 1.5rem;
  }
}
#sponsorships-box {
  background-color: rgb(242, 242, 242);
}
.action-details {
  padding: 2rem;
}
</style>
